import {Link} from '@primer/react'
import {useMergeControlState, useMergeControlInputs} from '../merge-control-context'

export function DisableAutoMergeInstructions() {
  const {isMergeQueueEnabled} = useMergeControlState()
  const {
    isStacked,
    stackedEntries,
    pullRequest: {autoMergeRequest},
  } = useMergeControlInputs()

  const autoMergeRangeCount = isStacked
    ? (stackedEntries?.filter(entry => entry.pull.isInAutoMergeRange).length ?? 0)
    : 0
  // Remove 1 from the count to account for the pull request being viewed.
  const otherPullRequestCount = Math.max(autoMergeRangeCount - 1, 0)

  return (
    <div className="flex-1">
      {otherPullRequestCount > 0 ? (
        stackedAutoMergeMessage(otherPullRequestCount, isMergeQueueEnabled)
      ) : (
        <SingleAutoMergeMessage isMergeQueueEnabled={isMergeQueueEnabled} mergeMethod={autoMergeRequest?.mergeMethod} />
      )}{' '}
      <Link
        inline
        href="https://docs.github.com/en/pull-requests/collaborating-with-pull-requests/incorporating-changes-from-a-pull-request/automatically-merging-a-pull-request"
      >
        Learn more about automatically merging a pull request.
      </Link>
    </div>
  )
}

function SingleAutoMergeMessage({
  isMergeQueueEnabled,
  mergeMethod,
}: {
  isMergeQueueEnabled: boolean
  mergeMethod?: string | null
}) {
  const autoMergeVerb = mergeMethod?.toLowerCase() ?? 'merge'
  const autoMergeMessage = isMergeQueueEnabled ? 'be added to the merge queue' : `${autoMergeVerb} automatically`

  return (
    <>
      This pull request will <span className="text-semibold">{autoMergeMessage}</span> when all requirements are met.
    </>
  )
}

function stackedAutoMergeMessage(otherPullRequestCount: number, isMergeQueueEnabled: boolean) {
  const others = otherPullRequestCount === 1 ? 'other' : 'others'
  const action = isMergeQueueEnabled ? 'be added to the merge queue' : 'automatically merge'

  return `This pull request and ${otherPullRequestCount} ${others} in the stack will ${action} when they all meet the merge requirements.`
}
